import React from "react";
import { Link } from "react-router-dom";
import { FaLock } from "react-icons/fa";

/**
 * Reusable Access Denied page component.
 *
 * Props:
 *   message   - optional custom message (default: "You don't have permission to view this page.")
 *   code      - optional error code (default: "403 forbidden")
 *   minHeight - optional root minHeight override (default: "100vh"); pass a smaller
 *               value when nesting inside a container that already reserves space
 *               for the header/sidebar, to avoid an extra scrollbar.
 */
const AccessDenied = ({
  message = "You don't have permission to view this page. If you believe this is a mistake, please reach out to your administrator.",
  code = "403 forbidden",
  minHeight = "100vh",
}) => (
  <div
    style={{
      minHeight,
      display: "grid",
      placeItems: "center",
      background: "#f9f9f9",
      padding: "1.5rem",
    }}
  >
    <div className="w-full max-w-md rounded-2xl border border-slate-200/80 bg-white p-10 text-center shadow-lg">
      <div
        className="mx-auto flex h-20 w-20 items-center justify-center rounded-full"
        style={{ background: "color-mix(in srgb, var(--app-icon-color, #A70E13) 12%, white)" }}
      >
        <FaLock className="text-3xl" style={{ color: "var(--app-icon-color, #A70E13)" }} />
      </div>

      <p
        className="mt-6 text-xs font-bold uppercase tracking-[0.2em]"
        style={{ color: "var(--app-icon-color, #A70E13)" }}
      >
        {code}
      </p>
      <h1 className="mt-1 text-3xl font-extrabold text-slate-900">Access Denied</h1>
      <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-slate-500">{message}</p>

      <div className="mt-8 flex items-center justify-center gap-3">
        <Link
          to="/"
          className="rounded-lg px-6 py-2.5 text-sm font-semibold text-white no-underline transition-opacity hover:opacity-90"
          style={{ background: "var(--app-ai-assistant-gradient, linear-gradient(135deg,#253978,#1a2a5e))" }}
        >
          Go to Home
        </Link>
      </div>
    </div>
  </div>
);

export default AccessDenied;
